import axios from 'axios';
import apiRequestHeaders from '../apiRequestHeaders';
import { PlaceDetails, PlacesFilter } from '../../features/places/placesSlice';

export function fetchPlaces(placesFilter: PlacesFilter) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: placesFilter,
  };

  return axios.get('/location/places/getplaces', config).then(res => res.data);
}

export function fetchPlaceDetails(placeId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { placeId },
  };

  return axios
    .get('/location/places/getplacedetails', config)
    .then(res => res.data);
}

export function addPlace(placeData: PlaceDetails) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/location/places/addplace', placeData, config)
    .then(res => res.data);
}

export function updatePlace(placeData: PlaceDetails) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .put('/location/places/updateplace', placeData, config)
    .then(res => res.data);
}

export function deletePlace(placeId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { placeId },
  };

  return axios
    .delete('/location/places/deleteplace', config)
    .then(res => res.data);
}
